import { getLocale } from '../lib/i18n'
import type { Item } from '../../shared/market/model'

/** Where a "public place" pickup happens, by area: the one place that area's neighbors already know. */
export const MEET_BY_AREA = { 'Isabel II': ['the plaza', 'la plaza'], Esperanza: ['the Malecón', 'el Malecón'], 'Other Vieques': ['the Wildlife Center', 'el Centro de Vida Silvestre'] } as const
export const meetPlace = (area: string) => MEET_BY_AREA[area as keyof typeof MEET_BY_AREA]?.[getLocale() === 'en' ? 0 : 1]
/** The pickup choice as one plain line that says what will actually happen. */
export function pickupLine(item: Pick<Item, 'pickup' | 'area'>): string {
  const en = getLocale() === 'en'
  if (item.pickup === 'public') { const place = meetPlace(item.area); return place ? (en ? `Meet at ${place}` : `Encuentro en ${place}`) : (en ? 'Meet in a public place' : 'Encuentro en un lugar público') }
  if (item.pickup === 'vehicle') return en ? 'The buyer picks it up' : 'El comprador lo recoge'
  return en ? 'Pickup point agreed privately' : 'Punto de recogido acordado en privado'
}
